import { ReactNode } from 'react'
import { IconPaths, IconSize, KTSVG } from '../../../_metronic/helpers'
import styles from './styles/TableFilters.module.css'

export type ActiveFilter = {
  key: string
  /** Nome do filtro ("Busca", "Status"). */
  label: string
  /** Valor exibido ("“teste”", "Ativa"). */
  value: string
  onRemove: () => void
}

type ActiveFiltersBarProps = {
  filters: ActiveFilter[]
  onClearAll: () => void
  /** Resumo à direita (ex.: "8 instituições encontradas"). */
  summary?: ReactNode
}

/**
 * Faixa "Filtros ativos: [Busca: “x” ×] [Status: Ativa ×] Limpar todos · resumo".
 * Não renderiza nada sem filtro ativo. Cada × remove só aquele filtro.
 */
export const ActiveFiltersBar = ({ filters, onClearAll, summary }: ActiveFiltersBarProps) => {
  if (!filters.length) return null

  return (
    <div className={styles.activeFilters}>
      <div className={styles.activeFiltersList}>
        <span className={styles.activeFiltersLabel}>Filtros ativos:</span>
        <ul className={styles.filterChips} aria-label='Filtros ativos'>
          {filters.map((filter) => (
            <li key={filter.key} className={styles.filterChip}>
              <span>
                <strong>{filter.label}:</strong> {filter.value}
              </span>
              <button
                type='button'
                className={styles.filterChipRemove}
                onClick={filter.onRemove}
                aria-label={`Remover filtro ${filter.label}: ${filter.value}`}
                title='Remover filtro'
              >
                <span aria-hidden='true' className='d-flex'>
                  <KTSVG path={IconPaths.XMark} size={IconSize.ExtraSmall} />
                </span>
              </button>
            </li>
          ))}
        </ul>
        <button type='button' className={styles.clearAll} onClick={onClearAll}>
          Limpar todos
        </button>
      </div>
      {summary && (
        <span role='status' className={styles.activeFiltersSummary}>
          {summary}
        </span>
      )}
    </div>
  )
}
